module.exports = __webpack_public_path__ + "img/confirmations.3aeae725.png";